import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource, MatDialog, MatPaginator, MatSort, Sort } from '@angular/material';
import { WebConstants } from 'src/app/util/web.constants';
import { ToastrService } from 'ngx-toastr';
import { ZoneService } from 'src/app/services/zone.service';
import { first } from 'rxjs/operators';
import { TokenStorage } from 'src/app/util/token.storage';
import { ZoneAddDialogComponent } from './zone-add-dialog/zone-add-dialog.component';
import { ZoneUpdateDialogComponent } from './zone-update-dialog/zone-update-dialog.component';
import { ZoneFileUploaderComponent } from './zone-file-uploader/zone-file-uploader.component';
import { ExcelExportDataService } from 'src/app/excelService/excel-export-data.service';
import { AngularCsv } from 'angular7-csv/dist/Angular-csv'

@Component({
  selector: 'app-zone-management',
  templateUrl: './zone-management.component.html',
  styleUrls: ['./zone-management.component.scss']
})
export class ZoneManagementComponent implements OnInit {

  public dataSource = new MatTableDataSource();
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  public displayedColumns: string[] = [
    'zoneId',
    'zoneName',
    'parkingType',
    'description',
    'duration',
    'gracePeriod',
    'multipleTicket',
    // 'status',
    'actions'
  ];

  options = {
    fieldSeparator: ',',
    quoteStrings: '',
    decimalseparator: '.',
    showLabels: true,
    showTitle: false,
    useBom: true,
    headers: ['Zone ID', 'Zone Name', 'Description', 'Parking Type', 'Multiple Ticket', 'Duration', 'Grace Period']
  };

  public data;
  public tempId;
  public sampleData: any;
  public title: string = WebConstants.MENU_NAMES.ZONE;
  Permitdata: any;

  constructor(
    public toastrService: ToastrService,
    public zoneService: ZoneService,
    public tokenStorage: TokenStorage,
    public dialog: MatDialog,
    public excelExportDataService: ExcelExportDataService,) { }

  ngOnInit() {
    this.getAllZone();
  }

  getAllZone(): void {
    this.zoneService.getAll()
      .pipe(first())
      .subscribe(response => {
        if (response && response.code === WebConstants.STATUS.CODE_SUCCESS) {
          this.data = response.data.reverse();
          this.dataSource = new MatTableDataSource<unknown>(this.data);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        } else {
          this.toastrService.error(response.value, "Failed To Load Data!")
        }
      });
  }

  getTempId(obj: any){
    this.tempId = obj;
  }

  applyFilter(event: Event): void {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  deleteZone(zone: any): void {
    this.zoneService.deleteZone(zone)
    .pipe(first())
    .subscribe(response => {
      if (response && response.code === WebConstants.STATUS.CODE_SUCCESS) {
        if(response.data == null){
          this.toastrService.success(response.value, "Zone Deleted Successfully!");
        }
        else{
          this.toastrService.error(response.data, "Error");
        }
        this.getAllZone();
      } else {
        this.toastrService.error(response.value, "Failed To Delete Data!");
      }
    });
  }


  // checkDelete(zone: any): void{
  //   let datalength = this.Permitdata.filter(z=>z.zone == zone.zoneId).length;
  //   if(datalength==0){
  //     this.deleteZone(zone);
  //   }
  //   else if(datalength==1){
  //     this.toastrService.error("This zone have permitted vehicle");
  //   }
  //   else if(datalength>1){
  //     this.toastrService.error("This zone have permitted vehicles");
  //   }
  // }

  

  addZoneDialog(): void {
    const dialogRef = this.dialog.open(ZoneAddDialogComponent, {
      data: null,
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result === true) {
        this.getAllZone();
      }      
    });
  }

  updateZoneDialog(data: any): void {
    const dialogRef = this.dialog.open(ZoneUpdateDialogComponent, {
      data: data,
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result === true) {
        this.getAllZone();
      }
    });
  }

  exportZoneCSV(): void {

    let dataForExcel = [];
    let count = 1;

    this.data.forEach((row: any) => {
      let rowData = [count, row.zoneId, row.zoneName, row.description, row.parkingType, row.multipleTicket? "Yes":"No", row.duration, row.gracePeriod]
      dataForExcel.push(rowData);
      count++;
    });
  
    let reportData = {
      title: "ZONE DATA",
      data: dataForExcel,
      headers: ['S No.', 'Zone ID', 'Zone Name', 'Zone Description', 'Parking Type', 'Multiple Tickets', 'Duration', 'Grace Period']
    };

    this.excelExportDataService.exportExcel(reportData)
  }

  exportSampleCSV(): void{

    this.sampleData = [
      {
        zoneId: "4413",
        zoneName: "Herman Armstrong",
        description: "Permitted",
        parkingType: "2",
        multipleTicket: "No",
        duration: "10",
        gracePeriod: "5",
      },
      {
        zoneId: "8787",
        zoneName: "Block1",
        description: "Parkmobile",
        parkingType: "1",
        multipleTicket: "Yes",
        duration: "30",
        gracePeriod: "10",
      },
      {
        zoneId: "439114",
        zoneName: "Don Boat Ramp-Maritana Drive",
        description: "Flowbird",
        parkingType: "1",
        multipleTicket: "No",
        duration: "15",
        gracePeriod: "3",
      },
    ];

    new AngularCsv(this.sampleData, "SampleCSV", this.options);
  }

  importZoneCSV(): void{

    const dialogRef = this.dialog.open(ZoneFileUploaderComponent, {
      width: '550px',
      data: null,
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe(result => {
      this.getAllZone();
    });
    
  }

}
